export async function request(path, payload) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(`/ted_care_board/${path}`, {
      method: payload ? "POST" : "GET",
      credentials: "same-origin",
      cache: "no-store",
      signal: controller.signal,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
      },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    if (
      response.redirected ||
      response.status === 401 ||
      !response.headers.get("content-type")?.includes("application/json")
    ) {
      const error = new Error("Your session has expired. Sign in again, then reload this board.");
      error.sessionExpired = true;
      throw error;
    }
    const result = await response.json();
    if (!response.ok) {
      const error = new Error(result.error || "Unable to save. Refresh and try again.");
      error.status = response.status;
      throw error;
    }
    return result;
  } catch (error) {
    if (error.name === "AbortError")
      throw new Error(
        "The request timed out. Refresh to check whether it saved. Retrying the same action is safe."
      );
    throw error;
  } finally {
    clearTimeout(timer);
  }
}

export const requestKey = () => window.crypto.randomUUID();
export const labels = {
  created: "Item added",
  edited: "Wording or date edited",
  acknowledged: "Acknowledged",
  care_performed: "Care performed",
  not_completed: "Seen but not completed",
  completed: "Completed",
  note: "Note added",
  reviewed: "Monthly review completed",
  closed: "Closed",
  withdrawn: "Withdrawn, not completed",
  archived: "TED follow-up archived",
  reactivated: "TED follow-up reactivated"
};

export function time(value, zone, full = false) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: zone,
    hour: "numeric",
    minute: "2-digit",
    ...(full ? { year: "numeric", month: "short", day: "numeric" } : {})
  }).format(new Date(value));
}
